import { Button } from '@cibli/shared';
import { ArrowLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { CloseTypeEnum } from '@/features/common/components/Header';
import IconButton from '@/features/common/components/IconButton';
import MainLayout from '@/features/common/components/MainLayout';

interface Props {
  onCancel: () => void;
  onBack?: () => void;
  onAskedToBeContacted?: () => void;
}

export default function NoJobsScreen({ onCancel, onBack, onAskedToBeContacted }: Props) {
  const { t } = useTranslation();
  const magnifyingImage = '/magnifiying-256.png';
  return (
    <MainLayout
      className="gap-12 md:gap-20"
      closeType={CloseTypeEnum.End}
      onClose={onCancel}
      rightContent={
        onBack ? (
          <IconButton
            icon={<ArrowLeft strokeWidth={3} className="min-h-6 min-w-6" />}
            onClick={onBack}
          />
        ) : undefined
      }
    >
      <img src={magnifyingImage} alt="" className="size-[128px] md:size-[180px] lg:size-[200px]" />
      <div className="flex flex-col gap-4 sm:gap-6 max-w-xl text-center">
        <div className="text-3xl md:text-4xl lg:text-5xl text-balance">
          {t('MatchingJobs.title_no_jobs')}
        </div>
        <div className="text-lg md:text-xl lg:text-2xl text-balance">
          {t('MatchingJobs.no_job_desc')}
        </div>
      </div>
      <Button size="lg" className="w-full sm:w-auto" onClick={onAskedToBeContacted ?? onCancel}>
        {t('MatchingJobs.be_contacted')}
      </Button>
    </MainLayout>
  );
}
